import * as React from "react"
import NavBar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {Divider} from "@mui/material";
import Slider from "react-slick";


export default function Cartoon() {
  const {t} = useTranslation()
  const [searchParams] = useSearchParams();

  const tableData = [
    {
      name: 'سایز 1',
      length: '10',
      width: '10',
      height: '15',
      img: require('./../../assets/img/cartoon/1.png')
    },
    {
      name: 'سایز 2',
      length: '10',
      width: '15',
      height: '20',
      img: require('./../../assets/img/cartoon/2.png')
    },
    {
      name: 'سایز 3',
      length: '15',
      width: '20',
      height: '20',
      img: require('./../../assets/img/cartoon/3.png')
    },
    {
      name: 'سایز 4',
      length: '20',
      width: '20',
      height: '30',
      img: require('./../../assets/img/cartoon/4.png')
    },
    {
      name: 'سایز 5',
      length: '20',
      width: '25',
      height: '35',
      img: require('./../../assets/img/cartoon/5.png')
    },
    {
      name: 'سایز 6',
      length: '20',
      width: '35',
      height: '45',
      img: require('./../../assets/img/cartoon/6.png')
    },
    {
      name: 'سایز 7',
      length: '25',
      width: '30',
      height: '40',
      img: require('./../../assets/img/cartoon/7.png')
    },
    {
      name: 'سایز 8',
      length: '30',
      width: '40',
      height: '45',
      img: require('./../../assets/img/cartoon/8.png')
    },
    {
      name: 'سایز 9',
      length: '35',
      width: '45',
      height: '55',
      img: require('./../../assets/img/cartoon/9.png')
    },

  ]

  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 790,
        settings: {
          arrows: true,
        }
      }
    ]
  };

  return (
     <>
       <NavBar/>

       <div className="cartoonPage">
         <div className="container">
           <div className="row">
             <div className="col-12 col-lg-6 mb-4">
               <h2>{t("cartoon.t1")}</h2>
               <p>{t("cartoon.t2")}</p>
             </div>

             <div className="col-12 col-lg-6 mb-4">
               <h2>{t("cartoon.t3")}</h2>
               <p>{t("cartoon.t4")}</p>
             </div>
           </div>

           <Divider/>


           <div className="cartoonList">
             <h2>{t("cartoon.t5")}</h2>


             <div className="d-none d-lg-flex">
               <div className="row">
                 {
                   tableData?.map((item, index) => {
                     return <div className="col-12 col-md-6 col-lg-4 mb-4">
                       <div className="item">
                         <div className="desc">
                           <p>{t("cartoon.t6") + ' ' + (index + 1)}</p>
                           <span>{t("cartoon.t7") + ' ' + item?.length} cm</span>
                           <span>{t("cartoon.t8") + ' ' + item?.width} cm</span>
                           <span>{t("cartoon.t9") + ' ' + item?.height} cm</span>
                         </div>
                         <div className="img">
                           <img src={item?.img} alt={t("cartoon.t6") + (index + 1)}/>
                         </div>
                       </div>
                     </div>
                   })
                 }
               </div>
             </div>


             <div className="d-block d-lg-none">
               <Slider {...settings}>
                 {
                   tableData?.map((item, index) => {
                     return <div>
                       <div className="item">
                         <div className="img">
                           <img src={item?.img} alt={t("cartoon.t6") + (index + 1)}/>
                         </div>
                         <div className="desc">
                           <p>{t("cartoon.t6") + ' ' + (index + 1)}</p>
                           <span> cm {t("cartoon.t7") + ' ' + item?.length + ''}</span>
                           <span> cm {t("cartoon.t8") + ' ' + item?.width}</span>
                           <span> cm {t("cartoon.t9") + ' ' + item?.height}</span>
                         </div>
                       </div>
                     </div>
                   })
                 }
               </Slider>
             </div>


           </div>
         </div>
       </div>
     </>
  )
}
